module.exports = __webpack_public_path__ + "img/explorer-21.02c3f287.jpg";